module.exports = __webpack_public_path__ + "img/icon-warning-icing-3.164e1664.svg";